import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import ManageRecipientsChild from "./ManageRecipientsChild";

const ManageRecipients = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ManageRecipientsChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ManageRecipients;
